import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const strategies = [
  { id: 'conservative', label: 'Conservative', icon: 'Shield', color: '#00D4FF', offer: '$2,590,000', probability: '45%', desc: 'Low-ball offer to test vendor flexibility. Best for properties with extended DOM or motivated sellers.', pros: ['Maximum savings if accepted', 'Tests vendor motivation', 'Room to negotiate up'], cons: ['May offend vendor', 'Lower acceptance chance', 'Could lose to competing offers'] },
  { id: 'balanced', label: 'Balanced', icon: 'Scale', color: '#00FF88', offer: '$2,720,000', probability: '72%', desc: 'Market-aligned offer showing genuine interest. Best for fairly priced properties in stable markets.', pros: ['Good acceptance probability', 'Shows genuine interest', 'Leaves negotiation room'], cons: ['Not the cheapest option', 'May need to increase', 'Moderate competition risk'] },
  { id: 'aggressive', label: 'Aggressive', icon: 'Zap', color: '#FFAA00', offer: '$2,800,000', probability: '89%', desc: 'Strong offer near asking price. Best for high-demand properties or when you must secure the deal.', pros: ['Highest acceptance rate', 'Beats competing offers', 'Shows strong commitment'], cons: ['Paying near full price', 'Less negotiating room', 'May overpay in soft market'] },
];

const StrategySelector = () => {
  const [selected, setSelected] = useState('balanced');
  const active = strategies?.find(s => s?.id === selected);

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Strategy Selector</h3>
      <div className="grid grid-cols-3 gap-3 mb-6">
        {strategies?.map(s => (
          <button key={s?.id} onClick={() => setSelected(s?.id)} className="p-3 rounded-xl border transition-all duration-200 text-center" style={{ borderColor: selected === s?.id ? s?.color : 'rgba(255,255,255,0.1)', background: selected === s?.id ? `${s?.color}15` : 'transparent', boxShadow: selected === s?.id ? `0 0 15px ${s?.color}30` : 'none' }}>
            <Icon name={s?.icon} size={20} color={selected === s?.id ? s?.color : '#888'} />
            <p className="text-xs font-medium mt-1" style={{ color: selected === s?.id ? s?.color : '#888' }}>{s?.label}</p>
            <p className="text-sm font-bold mt-1" style={{ color: selected === s?.id ? s?.color : '#aaa' }}>{s?.offer}</p>
          </button>
        ))}
      </div>
      {active && (
        <div className="space-y-4">
          <div className="flex items-center justify-between p-3 rounded-lg" style={{ background: `${active?.color}10` }}>
            <span className="text-sm text-muted-foreground">Success Probability</span>
            <div className="flex items-center gap-2">
              <div className="w-24 h-2 rounded-full bg-muted overflow-hidden">
                <div className="h-full rounded-full" style={{ width: active?.probability, background: active?.color }} />
              </div>
              <span className="font-bold" style={{ color: active?.color }}>{active?.probability}</span>
            </div>
          </div>
          <p className="text-sm text-muted-foreground">{active?.desc}</p>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <p className="text-xs font-semibold text-green-400 mb-2">Pros</p>
              {active?.pros?.map((p, i) => <p key={i} className="text-xs text-muted-foreground flex items-start gap-1 mb-1"><span className="text-green-400 mt-0.5">+</span>{p}</p>)}
            </div>
            <div>
              <p className="text-xs font-semibold text-red-400 mb-2">Cons</p>
              {active?.cons?.map((c, i) => <p key={i} className="text-xs text-muted-foreground flex items-start gap-1 mb-1"><span className="text-red-400 mt-0.5">-</span>{c}</p>)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StrategySelector;
